import { useState } from "react";
import { Button, type Theme } from "@mui/material";
import { MesfModal } from "@dexteel/mesf-core";
import Grid2 from "@mui/material/Grid2";
import { createStyles, makeStyles } from "@mui/styles";
import { useForm } from "react-hook-form";
import CronScheduler from "@/components/cron-scheduler/src/Scheduler";
import { RecoilRoot } from "recoil";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		scheduler: {
			"& .MuiAutocomplete-root": {
				width: "100%",
				marginBottom: theme.spacing(3),
			},
			"& .MuiFormControl-root": {
				width: "100%",
				marginTop: theme.spacing(2),
				marginBottom: theme.spacing(2),
			},
			"& .MuiInputLabel-root": {
				fontSize: "1rem",
				marginBottom: theme.spacing(1),
			},
		},
		error: {
			color: theme.palette.error.main,
			fontSize: "0.875rem",
			marginTop: theme.spacing(1),
		},
	}),
);

type Props = {
	show: boolean;
	onClose: () => void;
	value: string | null;
	onChange: (value: string) => void;
};

export const CronExpressionModal = ({
	show,
	onClose,
	value,
	onChange,
}: Props) => {
	const classes = useStyles();
	const initialCronValue = value || "0 0 * * *";
	const [currentCronExp, setCurrentCronExp] = useState(initialCronValue);
	const [cronError, setCronError] = useState("");
	const { handleSubmit } = useForm();

	const onSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		e.stopPropagation();

		if (!cronError) {
			onChange(currentCronExp);
			onClose();
		}
	};

	const handleClose = () => {
		setCurrentCronExp(initialCronValue);
		onClose();
	};

	return (
		<MesfModal
			title="SCHEDULE"
			open={show}
			handleClose={handleClose}
			maxWidth="sm"
			id="cron-expression-modal"
		>
			<form onSubmit={onSubmit} onClick={(e) => e.stopPropagation()}>
				<MesfModal.Content dividers>
					<div className={classes.scheduler}>
						{/* @ts-expect-error - Recoil 0.3.1 type definitions are incomplete for React 18 children prop */}
						<RecoilRoot>
							<CronScheduler
								cron={currentCronExp}
								setCron={setCurrentCronExp}
								setCronError={setCronError}
								isAdmin={false}
							/>
						</RecoilRoot>
					</div>

					{cronError && <div className={classes.error}>{cronError}</div>}
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 16px 16px" }}>
					<Grid2 container spacing={2} justifyContent="flex-end" width="100%">
						<Grid2 size={{ md: 3, xs: 12 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={handleClose}
							>
								Cancel
							</Button>
						</Grid2>
						<Grid2 size={{ md: 3, xs: 12 }}>
							<Button
								type="submit"
								color="primary"
								variant="contained"
								disabled={!!cronError}
								fullWidth
							>
								Save
							</Button>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</form>
		</MesfModal>
	);
};
